import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CanvasService } from "@services/canvas.service";

@Component({
    selector: "confirm-leave",
    templateUrl: "confirm-leave.component.html",
    styleUrls: ["confirm-leave.component.scss"],
    standalone: false
})
export class ConfirmLeaveComponent {
  message: string = "Are you sure?";
  confirmButtonText = "Yes";
  cancelButtonText = "Cancel";
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private canvasService: CanvasService,
    private dialogRef: MatDialogRef<ConfirmLeaveComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
    }
  }

  close(): void {
    this.dialogRef.close(false);
  }

  navigate(): void {
    this.dialogRef.close(true);
  }
  saveandnavigate(): void {
    this.canvasService.triggerSave();
    this.dialogRef.close(true);
  }
}
